import React from "react";

export const RecepiesContext=React.createContext({});